export const BASE_ASSETS_URL = process.env.REACT_APP_BASE_ASSETS_URL || 'https://www.drockerhof.it/assets/'
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || 'https://www.drockerhof.it/api/'
